/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum CanvasToken {
  MOCK_NAME = -10,
  MOCK_ID = -9,
  MOCK_PARAM_STRING = -8,
  MOCK_PARAM_BITMAP = -7,
  MOCK_PARAM_VARINT = -6,
  MOCK_PARAM_VARSINT = -5,
  MOCK_PARAM_VARFLOAT = -4,
  MOCK_PARAM_ZERO = -3,
  OP = 0,
  END = 1,
  BITMAP = 2,
  COLOR = 3,
  DEST = 4,
  DEST_ZERO = 5,
  SRC = 6,
  SRC_ZERO = 7,
  FLAG1 = 8,
  LINE_WIDTH = 9,
  MATRIX = 10,
  MATRIX6 = 11,
  NINEPATCH = 12,
  PATH = 13,
  POINT = 14,
  POINTF = 15,
  POINTF2 = 16,
  POINTF3 = 17,
  SCALE_OVERRIDE = 18,
  SHADER = 19,
  TEXT = 20,
  VALUE = 21,
  VIEWID = 22,
  VIEWID64 = 23,
  ULONG = 24,
  RECT = 25,
  FIXEDFLOAT = 26,
  PATH_FILL_TYPE = 27,
  TEXT_BOUNDS = 50,
  TEXT_CHAR_SPACING = 51,
  TEXT_FONT = 52,
  TEXT_RENDER_MODE = 53,
  TEXT_SIZE = 54,
  TEXT_WORD_SPACING = 55,
  PAINT_BITMAP = 80,
  PAINT_COLOR = 81,
  PAINT_NULL = 82,
  PAINT_PORTER_DUFF_COLOR = 83,
  PAINT_PORTER_DUFF_COLOR_MODE = 84,
  PAINT_PORTER_DUFF_XFER_MODE = 85,
  PAINT_SHADER = 86,
  PAINT_SHADER_MATRIX = 87,
  PAINT_STROKE_WIDTH = 88,
  PAINT_STYLE = 89,
  PAINT_TEXT_ALIGN = 90,
  PAINT_TEXT_BOUNDS = 91,
  PAINT_TEXT_PRIVATE = 92,
  PAINT_TEXT_SIZE = 93,
  PAINT_TEXT_STYLE = 94,
  PAINT_TILE_X = 95,
  PAINT_TILE_Y = 96,
  PAINT_TYPEFACE = 97,
}
